import { gsap } from 'gsap'
import { useCallback, useEffect, useLayoutEffect, useRef } from 'react'

/**
 * The `useAnimationStandard`
 *
 * @param {object} ref - the ref
 * @param {boolean} isActive - whether is active
 */
const useAnimationStandard = (ref, isActive) => {
  const wasActive = useRef(false)
  const tl = useRef()
  const gEl = gsap.utils.selector(ref)

  /**
   * Layout Effect: On mount
   */
  useLayoutEffect(() => {
    gsap.set(gEl('g > *'), {
      opacity: 0
    })

    tl.current = gsap
      .timeline()
      .to(gEl('g[data-i] > *, g[data-l1] > *, g[data-l2] > *'), {
        opacity: 1,
        stagger: {
          each: 0.02,
          from: 'left'
        },
        ease: 'back.out',
        delay: 0,
        duration: 0.5
      })

    tl.current.duration(1)

    tl.current.pause()
  }, [])

  /**
   * Show the animation
   */
  const show = useCallback(() => {
    tl.current.play()
  }, [])

  /**
   * Hide the animation
   */
  const hide = useCallback(() => {
    tl.current.reversed(true)
  }, [])

  /**
   * Effect: When the `isActive` state changes
   */
  useEffect(() => {
    if (isActive === wasActive.current) {
      return
    }

    wasActive.current = isActive

    if (isActive) {
      show()

      return
    }

    hide()
  }, [isActive])

  /**
   * Effect: On mount/unmount
   */
  useEffect(() => {
    wasActive.current = false
    tl.current.progress(0)

    return () => {}
  }, [])
}

export default useAnimationStandard
